import React from 'react';
import PropTypes from 'prop-types';


import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import SingleFileUploadContainer from '../../../upload/addFilesDialog.component';
import {connect} from 'react-redux';
import {updateFileActive} from '../../../../store/actions/session.actions';

class MissingFileSessionRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    };
  }

  handleClick() {
    this.setState(state => ({ open: !state.open }));
  }

  render() {
    const { sessionId, filename } = this.props;

    return (
      <TableRow
        hover
        tabIndex={-1}
      >
        <TableCell>{filename}</TableCell>
        <TableCell>
          <SingleFileUploadContainer sessionId={sessionId} callback={this.handleUpload}></SingleFileUploadContainer>
        </TableCell>
      </TableRow>
    );
  }
}

MissingFileSessionRow.propTypes = {
  sessionId: PropTypes.string.isRequired,
  filename: PropTypes.string,
};

export default connect(null, { updateFileActive })(MissingFileSessionRow)
